import { Component, Optional } from '@angular/core';
import { ItemView, ItemViewProviderDirective } from '@ntap/core';
import { first } from 'rxjs';

import { OibService } from '@app/shared/services/oib.service';
import { OibServiceBaseComponent } from '@app/shared/components/oib-service-panel/oib-service-base.component';

@Component({
  selector: 'app-oib-service-subjekt-action',
  templateUrl: './oib-service-subjekt-action.component.html',
  styleUrls: ['./oib-service-subjekt-action.component.scss']
})
export class OibServiceSubjektActionComponent extends OibServiceBaseComponent {
  constructor(
    oibService: OibService,
    @Optional()
    itemViewProviderDirective: ItemViewProviderDirective<ItemView>
  ) {
    super(oibService, itemViewProviderDirective);
  }

  protected override checkExistingOib(): void {
    this.oib.reset();
    this.oibReadonly = false;

    if (!this.parrentFormData) {
      return;
    }

    const oib = this.parrentFormData['seup~subjekt~oib'];
    if (oib) {
      this.oib.setValue(oib);
      this.oibReadonly = true;
    }
  }

  protected override applyOibData(): void {
    const subjektId = this.parrentFormData['seup~subjekt~id'];

    this.oibService
      .applyForSubjekt(this.oib.value!, subjektId)
      .pipe(first())
      .subscribe({
        next: (response: any) => {
          this.showDialog = false;
          const updatedItem = Object.assign({}, this.parrentFormData, response);
          this.itemViewProviderDirective.updateItem(updatedItem);
        },
        error: (e) => this.handleApplyError(e)
      });
  }
}
